import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { Briefcase, Battery, Building2, Mountain, Sparkles, Gauge, Zap, Clock, MapPin, Weight } from 'lucide-react';

const ICONS: Record<string, any> = { Briefcase, Battery, Building2, Mountain, Sparkles, Gauge, Zap, Clock, MapPin, Weight };

// Lit les slides du hero depuis hero_slides ; repli sur le contenu fourni si vide / injoignable.
export function useHeroSlides<T>(fallback: T[]): T[] {
  const [slides, setSlides] = useState<T[] | null>(null);

  useEffect(() => {
    let active = true;
    supabase
      .from('hero_slides')
      .select('*')
      .eq('is_active', true)
      .order('display_order', { ascending: true })
      .then(({ data, error }: { data: any[] | null; error: any }) => {
        if (!active) return;
        if (error || !data || !data.length) { setSlides(null); return; }
        const mapped = data.map((r) => ({
          id: r.id,
          productId: r.product_slug || r.id,
          name: r.name,
          tagline: r.tagline || '',
          description: r.description || '',
          image: r.image || '',
          lifestyle: r.lifestyle !== false,
          specsMinimal: (r.specs_minimal || []).map((s: any) => ({ icon: ICONS[s.icon] || Battery, label: s.label })),
          specs: r.specs || [],
          primaryCta: { label: r.cta_label || 'Découvrir', to: r.cta_to || (r.product_slug ? `/products/${r.product_slug}` : '/products') },
          accent: r.accent || 'primary',
          basePrice: r.base_price ?? 0,
          priceLabel: r.price_label || '',
          priceAmount: r.price_amount || '',
          priceCurrency: r.price_currency || '',
          priceUnit: r.price_unit ?? '',
          priceSubtitle: r.price_subtitle || '',
        }));
        setSlides(mapped as unknown as T[]);
      })
      .then(undefined, () => { if (active) setSlides(null); });
    return () => { active = false; };
  }, []);

  return slides && slides.length ? slides : fallback;
}
